import { ORIENTATION } from "./constants";
export const defaultProps = {
    orientation: ORIENTATION.HORIZONTAL,
    disabled: false,
    css: undefined,
    width: "100%",
    onInput: () => { },
    onMoveEnd: () => { },
};
//# sourceMappingURL=interface.js.map